import { clsx, type ClassValue } from 'clsx'

/**
 * utils for classname
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}
